
<div class="row mt-1">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
